"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tooltip = require("../../../tooltip");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SelectedItem = function SelectedItem(_ref) {
  var children = _ref.children,
    id = _ref.selectProps.id;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "tip-".concat(id)
  }), /*#__PURE__*/_react["default"].createElement("span", {
    "data-tip": children,
    "data-for": "tip-".concat(id),
    "data-place": "top",
    className: "selected-value"
  }, children));
};
SelectedItem.propTypes = {
  children: _propTypes["default"].node.isRequired,
  selectProps: _propTypes["default"].shape({}).isRequired
};
var _default = exports["default"] = SelectedItem;